export default {
    averageTime: 'Average Time',
    mon: 'Mon',
    tues: 'Tue',
    wednes: 'Wed',
    thurs: 'Thu',
    fri: 'Fri',
    satur: 'Sat',
    sun: 'Sun'
}
